export default __webpack_public_path__ + "static/media/it-42.1740c47c.svg";